import { render, staticRenderFns } from "./address-book-list.vue?vue&type=template&id=f8e1127a&"
import script from "./address-book-list.vue?vue&type=script&lang=js&"
export * from "./address-book-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports